module.exports = __webpack_public_path__ + "static/media/sally_success.bb383703.png";